import * as React from "react";
const SvgXWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M4 14 14 4M14 14 4 4" />
  </svg>
);
export default SvgXWhite;
